<!-- missions.component.html -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>NOS MISSIONS</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>NOS MISSIONS</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="missions-section pb-100 pt-100">
    <div class="container">
        <div class="section-header">
            <h2>Nos Engagements</h2>
            <p>Découvrez comment nous façonnons l'avenir des PME à travers nos missions clés</p>
        </div>

        <div class="missions-grid">
            <!-- Mission 1 -->
            <div class="mission-card">
                <div class="mission-icon">
                    <i class="icofont-bullseye"></i>
                </div>
                <h3>Accompagnement des PME</h3>
                <p>Nous accompagnons les PME dans leur développement et leur croissance en leur offrant un soutien personnalisé et des solutions adaptées à leurs besoins spécifiques.</p>
            </div>

            <!-- Mission 2 -->
            <div class="mission-card">
                <div class="mission-icon">
                    <i class="icofont-light-bulb"></i>
                </div>
                <h3>Innovation Continue</h3>
                <p>Nous encourageons et soutenons l'innovation au sein des entreprises pour favoriser leur compétitivité sur les marchés locaux et internationaux.</p>
            </div>

            <!-- Mission 3 -->
            <div class="mission-card">
                <div class="mission-icon">
                    <i class="icofont-handshake-deal"></i>
                </div>
                <h3>Partenariats Stratégiques</h3>
                <p>Nous créons des ponts entre les entreprises, les institutions et les partenaires stratégiques pour favoriser les opportunités d'affaires et la croissance mutuelle.</p>
            </div>

            <!-- Mission 4 -->
            <div class="mission-card">
                <div class="mission-icon">
                    <i class="icofont-graduate"></i>
                </div>
                <h3>Formation et Développement</h3>
                <p>Nous proposons des programmes de formation et de développement des compétences pour renforcer les capacités des entrepreneurs et de leurs équipes.</p>
            </div>

            <!-- Mission 5 -->
            <div class="mission-card">
                <div class="mission-icon">
                    <i class="icofont-globe"></i>
                </div>
                <h3>Développement Durable</h3>
                <p>Nous intégrons les principes du développement durable dans nos actions pour promouvoir une croissance économique responsable et respectueuse de l'environnement.</p>
            </div>

            <!-- Mission 6 -->
            <div class="mission-card">
                <div class="mission-icon">
                    <i class="icofont-users-social"></i>
                </div>
                <h3>Réseautage d'Affaires</h3>
                <p>Nous facilitons la mise en relation des entreprises et la création de synergies pour développer des opportunités commerciales durables.</p>
            </div>
        </div>

        <div class="mission-values">
            <h2>Nos Valeurs</h2>
            <div class="values-container">
                <div class="value-item">
                    <i class="icofont-star"></i>
                    <h4>Excellence</h4>
                    <p>Nous visons l'excellence dans tout ce que nous entreprenons.</p>
                </div>
                <div class="value-item">
                    <i class="icofont-heart"></i>
                    <h4>Engagement</h4>
                    <p>Nous sommes engagés envers la réussite de nos partenaires.</p>
                </div>
                <div class="value-item">
                    <i class="icofont-refresh"></i>
                    <h4>Innovation</h4>
                    <p>Nous encourageons la créativité et l'innovation constante.</p>
                </div>
                <div class="value-item">
                    <i class="icofont-users-alt-3"></i>
                    <h4>Collaboration</h4>
                    <p>Nous croyons en la force du travail d'équipe et des partenariats.</p>
                </div>
            </div>
        </div>
    </div>
</section>